import { render, staticRenderFns } from "./DesignTracker.vue?vue&type=template&id=74f75c62&scoped=true&"
import script from "./DesignTracker.vue?vue&type=script&lang=js&"
export * from "./DesignTracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f75c62",
  null
  
)

export default component.exports